import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

import * as S from "./styles";

interface OverviewProps {
  description: string;
}

export const Overview = ({ description }: OverviewProps) => (
  <S.Row>
    <S.Description
      className="markup neru-markup"
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
    >
      {description}
    </S.Description>
  </S.Row>
);
